import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { StyledNormalWrapper, StyledPrimaryWrapper, StyledWrapper, } from './Navigation.style';
import { NavigationButton } from './NavigationButton';
export const Navigation = memo(function Navigation({ featuredItem, items, activeItem, onClick, onCollapse, variant, visible, }) {
    const handleCollapse = useCallback((visible) => {
        if (onCollapse && !visible) {
            onCollapse(visible);
        }
    }, [onCollapse]);
    return (_jsxs(StyledWrapper, { children: [featuredItem && (_jsx(StyledPrimaryWrapper, { variant: variant, children: _jsx(NavigationButton, { isFeatured: true, item: featuredItem, variant: variant, activeItem: activeItem, onClick: () => {
                        onClick === null || onClick === void 0 ? void 0 : onClick(featuredItem);
                        handleCollapse(visible);
                    } }, `primary-navigation-${featuredItem.type}-featured`) })), _jsx(StyledNormalWrapper, { variant: variant, children: items.map((item, index) => (_jsx(NavigationButton, { item: item, variant: variant, activeItem: activeItem, onClick: () => {
                        onClick === null || onClick === void 0 ? void 0 : onClick(item);
                        handleCollapse(visible);
                    } }, `normal-navigation-${item.type}-${index}`))) })] }));
});
//# sourceMappingURL=Navigation.js.map